import { ACTIVE_STATUSES } from 'store/journey/journey.type';
import { useAppSelector as useSelector } from './reduxHooks';

// useJourneyStatus hook
export default function useJourneyStatus() {
  const status = useSelector((state) => state.te.journey.status);
  const hasActivationDate = useSelector((state) => !!state.te.journey.activatedAt);

  return {
    journeyStatus: status,
    isJourneyLocked: ACTIVE_STATUSES.includes(status),
    hasActivationDate,
  };
}
